export default __webpack_public_path__ + "static/media/CRTorpedo.096bc56d.png";